import { Component, Input } from '@angular/core';
import { LandingFaq } from '../landing-page.models';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  standalone: false
})
export class FaqSectionComponent {
  @Input() faqs: LandingFaq[] = [];
}
